import './Spinner.css';

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
}

function Spinner({ size = 'medium' }: SpinnerProps) {
  return (
    <div className={`gk-spinner-container gk-spinner-${size}`}>
      <div className="gk-spinner"></div>
    </div>
  );
}

export default Spinner;
